<template>
  <div>
    <div v-if="loading">
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    </div>
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <div class="col">
              <h3>Importar datos de programas de retiro</h3>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12 float-right d-flex">
              <div class="input m-2" @click="clickInput">
                <span v-if="file" :style="{color: '#525f7f' }">{{ file.name }}</span>
                <span v-else>Seleccione un archivo...</span>
                <input id="input-file" type="file" accept=".xls,.xlsx" @change="setFile" hidden />
              </div>
              <button class="btn btn-primary float-right m-2" @click="importarDatos">
                Importar datos
              </button>
            </div>
            <div class="col-md-12">
              <label class="text-error" v-text="getValidationText(`file`)"></label>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <h3>Datos importados</h3>
              <div class="container-datos">
                <div class="box-datos">
                  <div class="titulo-dato">Plantas</div>
                  <div class="dato" v-for="planta in datos_importados.pr_plantas">{{ planta.nombre }}</div>
                </div>
                <div class="box-datos">
                  <div class="titulo-dato">Proveedores</div>
                  <div class="dato" v-for="proveedor in datos_importados.pr_proveedores">{{ proveedor.nombre }}</div>
                </div>
                <div class="box-datos">
                  <div class="titulo-dato">Tipos de estanques</div>
                  <div class="dato" v-for="tipo_estanque in datos_importados.pr_tipo_estanque">{{ tipo_estanque.nombre }}</div>
                </div>
                <div class="box-datos">
                  <div class="titulo-dato">Productos</div>
                  <div class="dato" v-for="producto in datos_importados.pr_productos">{{ producto.nombre }}</div>
                </div>
                <div class="box-datos">
                  <div class="titulo-dato">Especies</div>
                  <div class="dato" v-for="especie in datos_importados.pr_especies">{{ especie.nombre }}</div>
                </div>
              </div>
              <div v-if="!existen_datos" class="no-dato">No hay datos importados aún</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="swal-container"></div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  data: () => ({
    file: null,
    loading: false,
    validationErrors: {},
    datos_importados: {
      pr_plantas: [/* 
        {nombre: "TesttestTesttestTesttestTesttestTesttestTesttestTesttestTesttestTesttestTesttestTesttestTesttest"},
        {nombre: "Test 1"},
        {nombre: "Test 1"},
        {nombre: "Test 1"},
        {nombre: "Test 1"},
       */],
      pr_proveedores: [],
      pr_tipo_estanque: [],
      pr_productos: [],
      pr_especies: [],
    },
  }),
  mounted() {},
  methods: {

    clickInput(e) {
      document.getElementById("input-file").click();
    },

    setFile(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.file = file;
    },

    async importarDatos() {
      if (!this.file) {
        Swal.fire({
          icon: "warning",
          title: "Seleccione un archivo primero",
          showCloseButton: true,
          showConfirmButton: false,
          timer: 1500
        });
        return;
      };

      this.loading = true;

      const data = new FormData();
      data.append("file", this.file);

      const url = `${this.api}/programa_retiro/importar_datos`;
      const config = {
        headers: {
          Authorization: this.cabeceras_json.headers["Authorization"],
          "Content-Type": "multipart/form-data"
        }
      };

      await this.axios
        .post(url, data, config)
        .then(res => {
          this.datos_importados = res.data.data;
          Swal.fire({
            icon: "success",
            title: res.data.message,
            showCloseButton: true,
            showConfirmButton: false,
          });
          this.file = null;
        })
        .catch(e => {
          if (e.response.status === 400) {
            this.validationErrors = e.response.data.data;

          } else {
            // Mostrar un mensaje genérico de error
            Swal.fire({
              icon: "error",
              title: "¡Error!",
              text: "Ha ocurrido un error al importar datos",
              confirmButtonColor: "#2dce89"
            });
            console.error(e);
          }
        });
      this.loading = false;
    },

    getValidationText(key) {
      return this.validationErrors[key]
        ? this.validationErrors[key].join(", ")
        : "";
    },

    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"])
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    
    existen_datos() {
      return Object.values(this.datos_importados).some(array => array.some(dato => dato));
    },
  }
};
</script>

<style scoped>

.container-datos {
  display: flex;
  gap: 1rem;
}

.box-datos {
  width: 20%;
}

.titulo-dato {
  border: 1px solid #e9ecef;
  width: 100%;
  padding: 1rem;
  background-color: #468faf;
  color: white;
}

.dato {
  border: 1px solid #e9ecef;
  border-top: 0;
  width: 100%;
  padding: 0.5rem;
  color: #525f7f;
}

.no-dato {
  font-size: 1.1rem;
  margin-top: 3rem;
  text-align: center;
}

.input {
  padding: 0.5rem;
  border: 1px solid #525f7f;
  border-radius: 0.5rem;

  flex-grow: 1;
  cursor: pointer; 
  color: gray;

  transition: all 0.3s ease;
}

.input:hover {
  background: rgb(250, 250, 250);
  border: 1px solid black;
}

.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  display: inline-block;
  width: 70px;
  height: 70px;
  border: 8px solid #fff;
  border-radius: 50%;
  border-top-color: #5e72e4;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.text-error {
  color: red;
  display: block;
}

</style>